import React, { Component } from 'react';
import Select from 'react-select';
import { connect } from 'react-redux';
import { PerfiosActions } from '../../Actions';
import { base64Logic } from "../../Shared/common_logic";
import FileUpload from '../../Components/FileUpload/FileUpload';
import PerfiosCallback from '../PerfiosCallback/PerfiosCallback';
import Loader from '../../Components/Loader/Loader';
import './Perfios.css';

class Perfios extends Component {

    state = {
        options: [
            { label: "Current Account", value: "AC" },
            { label: "Saving Account", value: "SB" },
            { label: "CC", value: "CC" },
            { label: "OD", value: "OD" }
        ],
        account: { label: "Current Account", value: "AC" },
        payload: null,
        checkError: {},
        payloadResponse: null,
        docs: [],
        passwordSelection: "",
        password: ""
    }

    componentWillMount() {
        const { history } = this.props;
        let base64_decode;
        let errors = {};
        
        let params = new URLSearchParams(history.location.search);
        let payload = params.get('payload');

        if (payload) {
            base64_decode = base64Logic(payload, "decode");
            errors['payload_missing'] = "";
        } else {
            errors['payload_missing'] = "Payload Missing";
        }

        if (Object.values(errors).some(e => e !== "")) {
            this.setState({ checkError: errors })
        }
        this.setState({ payload: base64_decode })
    }


    handleChange = selectedOption => {
        this.setState({ account: selectedOption });
    };

    UNSAFE_componentWillReceiveProps(nextProps) {
        const { perfios } = nextProps;
        if (perfios && Object.keys(perfios).length) {
            const payloadResponse = perfios.postResult && perfios.postResult.data.attributes;
            this.setState({ payloadResponse })
        }
    }

    submitNetBanking = statement => {
        const { payload, account, checkError, docs, passwordSelection, password } = this.state;
        let errors = {};
        let UpdateDocs = null;
        if (Object.values(checkError).some(e => e !== "")) {
            this.setState({ checkError: errors })
            return
        }

        if (payload.app_id === undefined || payload.app_id.length === 0) {
            errors['app_id'] = 'Require App ID';
        } else {
            errors['app_id'] = '';
        }

        if (payload.loan_application_id === undefined || payload.loan_application_id.length === 0) {
            errors['loan_application_id'] = 'Require Loan Application Id';
        } else {
            errors['loan_application_id'] = '';
        }

        if (statement.length && docs.length === 0) {
            errors['docs'] = 'Please Upload Documents';
        } else {
            errors['docs'] = '';
        }

        if (passwordSelection !== "" && passwordSelection !== "no")
            if (password === "")
                errors['password'] = 'Require Password';
            else
                errors['password'] = '';

        if (Object.values(errors).some(e => e !== "")) {
            this.setState({ checkError: errors })
            return
        }

        const { app_id, loan_application_id } = payload;
        if (statement.length) {
            if (passwordSelection === "yes") {
                UpdateDocs = docs.map(d => ({ document: d.document, password }))
            }
            this.props.postUploadStatement({
                app_id,
                loan_application_id,
                statements: UpdateDocs !== null ? UpdateDocs : docs
            })
        } else {
            this.props.postNetbanking({
                app_id,
                facility: ['SB','AC'].indexOf(account.value) === -1 ? account.value : "NONE",
                loan_application_id
            })
        }
        this.setState({ checkError: {} })
    }

    submitStatements = () => {
        this.submitNetBanking('statements')
    }

    componentDidUpdate() {
        if (document.getElementById('payload') !== null && document.getElementById('signature') !== null)
            if (document.getElementById('payload') !== "" && document.getElementById('signature').value !== "")
                document.getElementById('submitForm').submit()
    }

    getDocs = docs => {
        if (docs !== undefined) {
            const document = docs.map(d => ({ document: d }))
            this.setState({ docs: document })
        }
    }

    render() {
        const { REACT_APP_PERFIOS_CALLBACK_URL } = process.env;
        const { account, options, checkError, payload, payloadResponse, password, passwordSelection, docs } = this.state;
        const { perfios } = this.props;
        if (payloadResponse && payloadResponse !== null && Object.keys(payloadResponse).length) {
            return (<form method="post" id="submitForm" encType="application/x-www-form-urlencoded" action={REACT_APP_PERFIOS_CALLBACK_URL}>
                <input type="hidden" id="payload" name="payload" value={payloadResponse.payload} />
                <input type="hidden" id="signature" name="signature" value={payloadResponse.signature} />
            </form>)
        }
        return (
            <div className="container-fluid padd0 row m-0 p-0">
                <div className="col-md-12 d-flex p-0">
                    <div className="col-md-6 p-0">
                        <img src="https://mintifi.com/media/logo.png" alt="logo" className="pt-4 mb-4 ml-4" />
                    </div>
                </div>
                {
                    perfios.loading && <Loader />
                }
                {
                    perfios && perfios.result !== undefined && perfios.result.data !== undefined ? <PerfiosCallback msg="completed" /> :
                        perfios && Object.keys(perfios).length && 'error' in perfios && perfios.error !== undefined && perfios.error.status === 500 ? <PerfiosCallback msg="failure"/> :
                            <div className="col-md-12  p-0">
                                <div>
                                    <div className="text-center">
                                        <span><span className="heading perfiosColor">Bank Statement </span><label className="heading">Submission</label></span>
                                    </div>
                                    <div className="text-content">
                                        <p className="mb-0">You are about the submit Bank Account Statement details of your business with Mintifi Private Limited.</p>
                                        <p className="mb-0">Your data is protected with the highest security standards and will be shared across </p>
                                        <p>lenders associated with your loan application <strong className="text-id">ID - {payload && payload.loan_application_id}</strong></p>
                                    </div>
                                </div>
                                {checkError && Object.keys(checkError) && Object.keys(checkError).map(err => {
                                    return (
                                        <div style={{ textAlign: 'center' }}>
                                            {
                                                checkError[err].length > 0 ?
                                                    <div key={`mintifi_${err}`}>
                                                        <span className="col-md-4 m-auto" style={{ color: "crimson", fontSize: "16px" }}>
                                                            {checkError[err]}
                                                        </span>
                                                    </div> : null
                                            }
                                        </div>
                                    )
                                })}
                                {perfios && Object.keys(perfios).length && 'postError' in perfios && perfios.postError.errors !== undefined && perfios.postError.errors.length ? perfios.postError.errors.map(err => {
                                    return (
                                        <div style={{ textAlign: 'center' }}>
                                            {
                                                <div key={`mintifi_${err.code}`}>
                                                    <span className="col-md-4 m-auto" style={{ color: "crimson", fontSize: "16px" }}>
                                                        {err.code === "ER-AUTH-101" ? err.detail : err.code === "ER-GEN-202" ? err.detail : err.detail}
                                                    </span>
                                                </div>
                                            }
                                        </div>
                                    )
                                }) : null}
                                {perfios && Object.keys(perfios).length && 'error' in perfios && perfios.error.errors !== undefined && perfios.error.errors.length ? perfios.error.errors.map(err => {
                                    return (
                                        <div style={{ textAlign: 'center' }}>
                                            {
                                                <div key={`mintifi_${err.code}`}>
                                                    <span className="col-md-4 m-auto" style={{ color: "crimson", fontSize: "16px" }}>
                                                        {err.detail}
                                                    </span>
                                                </div>
                                            }
                                        </div>
                                    )
                                }) : null}
                                {
                                    perfios && Object.keys(perfios).length && 'postError' in perfios && perfios.postError.message !== undefined ? <div className="col-md-12 d-flex" style={{ position: 'absolute', textAlign: 'center' }}>
                                        <div className="col-md-4 m-auto">
                                            <span className="col-md-4 m-auto" style={{ color: "crimson", fontSize: "16px" }}>
                                                {perfios.postError.message}
                                            </span>
                                        </div></div> : null
                                }
                                <div className="col-md-12 padd0 p-0">
                                    <div>
                                        <div className="col-md-3 m-auto padd0">
                                            <p className="mb-0 perfios_label-text mb-2 mt-5">Select Account Type<span className="red">*</span></p>
                                            <Select
                                                value={account}
                                                onChange={this.handleChange}
                                                options={options}
                                            />
                                        </div>
                                        <div className="col-md-3 m-auto padd0">
                                            <p className="mb-0 mt-4 perfios_label-text mb-2">Upload PDF Statements<span className="red">*</span></p>
                                            <div className="d-flex fileUpload">
                                                <div className="col-md-12 p-0 FlexNone">
                                                    <FileUpload getDocs={this.getDocs} />
                                                </div>
                                            </div>
                                            {
                                                docs.length ?
                                                    <div className="d-flex mt-3 fileUpload">
                                                        <div className="col-md-12 p-0 FlexNone">
                                                            <p className="mb-0 mt-2 perfios-statements">Password </p>
                                                            <div className="container pwd" onChange={event => this.setState({ passwordSelection: event.target.value, password: "" })}>
                                                                <input type="radio" id="yes" name="password" value="yes" />
                                                                <label htmlFor="yes" className="radio1">Yes</label>
                                                                <input type="radio" id="no" name="password" value="no" />
                                                                <label htmlFor="no" className="radio2">No</label>
                                                            </div>
                                                            {
                                                                passwordSelection === "yes" ?
                                                                    <input type="password" className="pwd-input" value={password} onChange={event => this.setState({ password: event.target.value })} />
                                                                    : null
                                                            }
                                                        </div>
                                                    </div> : null
                                            }
                                            {
                                                perfios && perfios.result === undefined ?
                                                    <div className="col-md-12 mt-2 d-flex padd0 justify-content-end">
                                                        <div className="paddlr20 grid padd0 m-0">
                                                            <button type="button" disabled={checkError && Object.keys(checkError).length && 'payload_missing' in checkError && Object.values(checkError['payload_missing']).length ? true : false} className="perfiosBtnSubmit w-100 float-right pl-3 pr-3" onClick={this.submitStatements}>Submit <img src="/images/arrow_green.png" alt="icon" className="m-0 dispNone perfios-arrow" /></button>
                                                        </div>
                                                    </div> : null
                                            }
                                            {account.value === "AC" || account.value === "SB" ?
                                                <>
                                                    <div className="center-OR">
                                                        <div className="border-line"></div> <span className="orCircle">OR</span> <div className="border-line"></div>
                                                    </div>
                                                    <div className="d-flex fileUpload">
                                                        <div className="col-md-12 p-0 FlexNone">
                                                            <div className="container">
                                                                <p className="mb-0 mt-2 perfios-statement">Submit your Bank Statement Via NetBanking We do not </p>
                                                                <p className="perfios-statement">Store your customer ID or Password</p>
                                                                <button type="button" disabled={checkError && Object.keys(checkError).length && 'payload_missing' in checkError && Object.values(checkError['payload_missing']).length ? true : false} className="mb-3 perfios-Btn" onClick={this.submitNetBanking}>Submit via net banking</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </> : null
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                }
            </div>
        )
    }
}

function mapState(state) {
    const { perfios } = state;
    return { perfios };
}

const actionCreators = {
    postNetbanking: PerfiosActions.postNetbanking,
    postUploadStatement: PerfiosActions.postUploadStatement
};

export default connect(mapState, actionCreators)(Perfios);